import { render, staticRenderFns } from "./YourFeed.vue?vue&type=template&id=548d0afc&"
import script from "./YourFeed.vue?vue&type=script&lang=js&"
export * from "./YourFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports